import PhotoComponent from "./PhotoComponent.jsx";

export default PhotoComponent;
